import { render, staticRenderFns } from "./ModifyPwd.vue?vue&type=template&id=5af38c06"
import script from "./ModifyPwd.vue?vue&type=script&lang=js"
export * from "./ModifyPwd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports